import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'LOCATION_STORE_CHANGE';
let error;
let searchResults = [];
let locationList = {};
let location = null;
let createLocationError = null;
let locationSearchResults = [];
let locationPairs = [];
let locationPairsError = null;
let locationPairsResult;
const LocationStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    clearLocations() {
        searchResults = [];
        this.emitChange();
    },
    getLocationSearchResults() {
        return locationSearchResults;
    },
    getLocations() {
        return searchResults;
    },
    getLocation() {
        return location;
    },
    getLocationList() {
        return locationList;
    },
    getCreateLocationError() {
        return createLocationError;
    },
    getLocationPairs() {
        return locationPairs;
    },
    getLocationPairsResult() {
        return locationPairsResult;
    },
    getLocationPairsError() {
        return locationPairsError;
    },
    removeFavoriteLocation(locationId) {
        searchResults = searchResults.filter(l => l._id !== locationId);
    },
    removeLocationPair(pair) {
        locationPairs = locationPairs.filter(p => {
            return p._id !== pair._id;
        });
    },
    removeLocation(loc) {
        if (!loc || !loc.location_id || !locationList) {
            return null;
        }
        const newItems = locationList.items.filter(p => {
            return p._id !== loc.location_id._id;
        });
        locationList.items = newItems;
        return locationList;
    },
    updateLocationPair(pair) {
        locationPairs = locationPairs.map(p => {
            if (p._id === pair._id)
                p = pair;
            return p;
        });
    },
    clearCreateLocationError() {
        createLocationError = null;
        this.emitChange();
    },
    setLocations(r) {
        searchResults = r.map((item) => {
            const mappedItem = Object.assign(Object.assign({}, item), { value: item._id, type: item._type });
            if (item._type === 'Shipper') {
                mappedItem.name = item.company_name;
                const locations = (item.locations || []).map(location => location.location);
                mappedItem.locations = locations;
            }
            else if (item._type === 'Driver') {
                const firstName = (item.first_name || '').trim();
                const lastName = (item.last_name || '').trim();
                mappedItem.name = `${firstName} ${lastName}`.trim();
                if (item.carrier) {
                    mappedItem.carrier = item.carrier.name;
                }
            }
            return mappedItem;
        });
    },
});
LocationStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_LOCATIONS_LIST:
            locationList = action.locations;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_LOCATION_SEARCH:
            locationSearchResults = action.locations.items;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_LOCATION:
            location = action.location.location;
            createLocationError = null;
            LocationStore.emitChange();
            break;
        case ActionTypes.CREATE_LOCATION_FAIL:
            createLocationError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.SAVE_LOCATION_FAIL:
            error = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_LOCATIONS:
            LocationStore.setLocations(action.locations);
            LocationStore.emitChange();
            break;
        case ActionTypes.REMOVE_FAVORITE_LOCATION_SUCCESS:
            LocationStore.removeFavoriteLocation(action.locationId);
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_LOCATION_PAIRS:
            locationPairs = action.entity.items;
            locationPairsResult = action.entity;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_LOCATION_PAIRS_FAIL:
            locationPairsError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_CREATE_LOCATION_PAIR:
            locationPairs.push(action.entity.pair);
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_CREATE_LOCATION_PAIR_FAIL:
            locationPairsError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_LOCATION_PAIR:
            LocationStore.updateLocationPair(action.entity);
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_LOCATION_PAIR_FAIL:
            locationPairsError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DELETE_LOCATION_PAIR:
            LocationStore.removeLocationPair(action.entity);
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DELETE_LOCATION_PAIR_FAIL:
            locationPairsError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DELETE_LOCATION:
            LocationStore.removeLocation(action.entity.result);
            LocationStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DELETE_LOCATION_FAIL:
            locationPairsError = action.entity.message;
            LocationStore.emitChange();
            break;
        case ActionTypes.CLEAR_LOCATION:
            location = null;
            LocationStore.emitChange();
            break;
        default:
            break;
    }
});
export default LocationStore;
